import { AfterViewInit, Component, ContentChild, HostBinding, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { Observable, Subscription } from 'rxjs';
import { fadeInEnter } from 'src/app/models/animations';
import { ProductAvailability } from 'src/app/models/product';
import { SmartActionContext } from 'src/app/models/smart-actions.models';
import { AppTitleService } from 'src/app/services/app-title.service';
import { ServiceFactoryService } from 'src/app/services/global/service-factory.service';
import { TenantService } from 'src/app/services/tenant/tenant.service';
import { UserService } from 'src/app/services/user/user.service';
import { LazyLoaderService } from 'src/app/shared/lazy-loader/lazy-loader.service';
import { AlertService } from '../../services/alert.service';
import { MemberService } from '../../services/member/member.service';
import { BaseComponent } from '../../shared/base.component';




@AutoUnsubscribe()
@Component({
    selector: 'app-page-wrapper-component',
    templateUrl: './wrapper-page.component.html',
    styleUrls: ['./wrapper-page.component.scss'],
    animations: [
        fadeInEnter
    ]
})
export class WrapperPageComponent extends BaseComponent implements OnInit, AfterViewInit {

    private _titleType: string;
    smartActionContextSubscription: Subscription;
    activeView: 'default' | 'notifications' = 'default';

    ProductAvailability = ProductAvailability;

    @Input() hideOptions: boolean;

    @Input() hideDashboardButton: boolean;

    @Input() showFooter = true;

    @ContentChild('extraTitleTemplate', { static: true })
    extraTitleTemplate: TemplateRef<any>;


    @ContentChild('headerActionsTemplate', { static: true })
    headerActionsTemplate: TemplateRef<any>;

    @ContentChild('contentTemplate', { static: true })
    contentTemplate: TemplateRef<any>;

    @ContentChild('footerTemplate', { static: true })
    footerTemplate: TemplateRef<any>;


    @ContentChild('navigationOptionsTemplate', { static: true })
    navigationOptionsTemplate: TemplateRef<any>;

    @ContentChild('customViewTemplate', { static: false })
    customViewTemplate: TemplateRef<any>;

    @ContentChild('iconTemplate', { static: false })
    iconTemplate: TemplateRef<any>;




    @Input() icon: string;

    @Input() pageTitle: string;

    @Input() backLink: any;

    @Input() backLinkTooltip: string;


    @Input()
    style: any;

    @Input() showHeader = true;

    @ViewChild('smartActionContextMenu', { static: false }) smartActionContextMenu: ContextMenu;


    smartActionContext$: Observable<SmartActionContext>;
    smartActionContextActions: MenuItem[];


    member$ = this.memberService.member$;
    createdOrchestration: boolean;



    defaultHostClasses = `product-info product-page availability-active`;
    @HostBinding('class') hostClasses = this.defaultHostClasses;
    lazyLoader$$: Subscription;

    constructor(
        protected serviceFactory: ServiceFactoryService,
        protected lazyLoaderService: LazyLoaderService,
        public appTitleService: AppTitleService,
        protected alertService: AlertService,
        protected router: Router,
        public route: ActivatedRoute,
        protected memberService: MemberService,
        public userService: UserService,
        public tenantService: TenantService,
    ) {
        super();
    }


    ngOnInit() {

    }

    ngAfterViewInit() {

    }

    routerActivated($event) {
    }

    takeAction(event: any) {
        if (this.smartActionContextActions && this.smartActionContextActions.length === 1) {
            this.smartActionContextActions[0].command({ item: this.smartActionContextActions[0] });
        } else {
            event.preventDefault();
            event.stopPropagation();
            this.smartActionContextMenu.toggle(event);
            return false;
        }
    }

    toggleNotifications() {
        this.activeView = this.activeView === 'notifications' ? 'default' : 'notifications';
    }
}
